// Compara la versión guardada en localStorage con la versión actual de la API
export const compararVersionesLocalesYRemotas = async () => {
  const versionLocal = localStorage.getItem('appVersion');
  const versionRemota = await getAppVersion();
  if (versionLocal !== versionRemota) {
    return true;
  } else {
    return false;
  }
};
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const runningMainAsset = (extension) => {
  if (typeof document === 'undefined') return '';
  return [...document.querySelectorAll('script[src], link[rel="stylesheet"]')]
    .map((node) => node.src || node.href || '')
    .find((url) => new RegExp(`/static/(?:js|css)/main\\.[^/]+\\.${extension}(?:\\?|$)`).test(url)) || '';
};

const assetPathIsCurrent = (runningUrl, latestPath) => {
  if (!latestPath || !runningUrl) return true;
  return runningUrl.split('?')[0].endsWith(latestPath);
};

// El HTML cacheado apunta a main.[hash] viejo aunque el servidor ya publicó otro.
export const isAppShellStale = async () => {
  if (process.env.NODE_ENV !== 'production') return false;

  const currentJs = runningMainAsset('js');
  const currentCss = runningMainAsset('css');
  if (!currentJs && !currentCss) return false;

  try {
    const response = await fetch(`${process.env.PUBLIC_URL || ''}/asset-manifest.json`, {
      cache: 'no-store',
    });
    if (!response.ok) return false;

    const manifest = await response.json();
    const files = manifest?.files || {};
    const jsStale = !assetPathIsCurrent(currentJs, files['main.js']);
    const cssStale = !assetPathIsCurrent(currentCss, files['main.css']);
    return jsStale || cssStale;
  } catch (error) {
    console.error('Error consultando el shell de la app:', error);
    return false;
  }
};

export const peekAppVersion = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/account/version`, {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) return null;

    const data = await response.json();
    return data?.version || null;
  } catch (error) {
    console.error('Error consultando versión:', error);
    return null;
  }
};

export const getAppVersion = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/account/version`, {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error('Error al obtener la versión');
    }
    
    const data = await response.json();
    localStorage.setItem('appVersion', data.version);
    return data.version;
  } catch (error) {
    console.error('Error obteniendo versión:', error);
    return 'v1.0.0-dev';
  }
};
